import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'messageFilter',
})
export class MessageFilterPipe implements PipeTransform {

  transform(chats: any[], searchTerm: string): any[] {
    if (!chats || !searchTerm) {
      return chats;
    }
    return chats.filter(chat => 
      chat.name.toLowerCase().includes(searchTerm.toLowerCase()) || 
      chat.lastMessage.toLowerCase().includes(searchTerm.toLowerCase()));
  }

}
